import first from './assets/first.png';
import firstMini from './assets/first-mini.svg';
import second from './assets/second.png';
import secondMini from './assets/second-mini.svg';
import third from './assets/third.png';
import thirdMini from './assets/third-mini.svg';

export const MAX_COVERAGE_LABEL = 'max-coverage';

export const AVERAGE_BID_LABEL = 'average-bid';

export const FLEXIBLE_STRATEGY_LABEL = 'flexible-strategy';

export const INFO_BANNERS = [
  {
    title: 'Максимальный охват',
    description: 'Удерживает ставку для всех активных объявлений выше всех конкурентов',
    miniImage: firstMini,
    labelValue: MAX_COVERAGE_LABEL,
    image: first,
  },
  {
    title: 'Средняя ставка',
    description: 'Удерживает ставку для всех активных объявлений выше 50% конкурентов с продвижением',
    miniImage: secondMini,
    labelValue: AVERAGE_BID_LABEL,
    image: second,
  },
  {
    title: 'Гибкая стратегия',
    description:
      'Продвигает заданное кол-во объявлений с максимальным охватом, средней или ставкой, установленной вручную ',
    miniImage: thirdMini,
    labelValue: FLEXIBLE_STRATEGY_LABEL,
    image: third,
  },
];

export const OPTIONS = [
  { value: MAX_COVERAGE_LABEL, label: 'Максимальный охват' },
  { value: AVERAGE_BID_LABEL, label: 'Средняя ставка' },
  { value: FLEXIBLE_STRATEGY_LABEL, label: 'Гибкая стратегия' },
];
